var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5783C11.3793 11.5783 15 10.0974 15 6.28917C15 2.48097 11.3793 1 8 1C4.62069 1 1 2.48097 1 6.28917C1 7.16066 1.18962 7.91027 1.52256 8.54815C1.7301 8.94576 1.84652 9.38423 1.75459 9.81398L1.50144 10.9974C1.3763 11.5823 1.96095 12.0948 2.62835 11.9851L5.72513 11.4762C5.96855 11.4362 6.2181 11.4397 6.46271 11.4737C6.97174 11.5444 7.48864 11.5783 8 11.5783Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.25C5.5 6.52614 5.27614 6.75 5 6.75C4.72386 6.75 4.5 6.52614 4.5 6.25C4.5 5.97386 4.72386 5.75 5 5.75C5.27614 5.75 5.5 5.97386 5.5 6.25Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.25C8.5 6.52614 8.27614 6.75 8 6.75C7.72386 6.75 7.5 6.52614 7.5 6.25C7.5 5.97386 7.72386 5.75 8 5.75C8.27614 5.75 8.5 5.97386 8.5 6.25Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.25C11.5 6.52614 11.2761 6.75 11 6.75C10.7239 6.75 10.5 6.52614 10.5 6.25C10.5 5.97386 10.7239 5.75 11 5.75C11.2761 5.75 11.5 5.97386 11.5 6.25Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.8e921d0cdf94975885a9fff3c51db37a.svg";
export { ForwardRef as ReactComponent };